export const GET_GENERAL_SESSION_COOKIE = 'GET_GENERAL_SESSION_COOKIE';
export const SET_GENERAL_APP_COOKIE = 'SET_GENERAL_APP_COOKIE';
export const SET_FORM_VALIDATION = 'SET_FORM_VALIDATION';
export const SET_PROFILE_INFO = 'SET_PROFILE_INFO';
export const SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export const RESET_DEFAULT_STATE = 'RESET_DEFAULT_STATE';
export const FORM_IS_INVALID = 'FORM_IS_INVALID';
export const GET_INVITATION_CODES = 'GET_INVITATION_CODES';



// WEBPACK FOOTER //
// ./src/data/constants/authentication-constants.jsx